<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (hasNotReinvestmentFluxFull()) {
      <info [option]="optionInfo1">
        Vous devez saisir la répartition à 100% de vos supports en flux pour
        pouvoir continuer.
      </info>
    }
    <info [option]="{ icon: 'info' }">
      Le montant à réinvestir en flux est de
      <strong>{{ currentMonthlyPayment | number: '1.2-2' }} €</strong>.
    </info>

    <supports-table
      [supports]="supportsInvestmentFlux"
      [config]="supportsTable"
      (addSupport)="addSupport()"
      (removeSupport)="onSupportDeselect($event.value)"
    ></supports-table>
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
    [disabledNext]="disabledNextBtn()"
  ></form-footer>
</form>
<pr-modal
  clazz="pr-modal-confirm"
  display="neutral custom-modal-width"
  #modalSupport
>
  <div class="pr-modal-confirm-header d-flex align-items-center gap-s mbl">
    <pr-icon name="sp-plus"></pr-icon>
    <h4 class="man bold">Ajouter des supports</h4>
  </div>
  <form [formGroup]="criteriaSupportForm">
    <pr-input-abstract
      label="Type de support"
      class="mvl"
      style="display: block"
    >
      <mat-select formControlName="supportTypes" placeholder="Tous">
        <mat-option [value]="undefined">Tous</mat-option>
        @for (type of supportTypes | async; track type) {
          <mat-option [value]="type.id">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input-abstract>
    <pr-input-radio
      formControlName="enableViewAll"
      columns="3"
      [toggle]="true"
      [isDefault]="true"
      label="Voir les produits structurés expirés"
    >
    </pr-input-radio>

    <pr-search-input
      formControlName="autocomplete"
      placeholder="Rechercher un support"
      class="mbm"
    >
    </pr-search-input>
  </form>
  <pr-form-select-list #formSelectList>
    @for (support of supports; track support) {
      <pr-form-select-list-option
        [label]="support.name"
        [labelIcon]="support.favorite ? 'sp-cup' : undefined"
        [subLabel]="support.isin"
        [criteriasLoading]="criteriasLoading"
        [selected]="getSupportInvestmentFlux(support.isin)"
        [criterias]="[
          {
            label: 'Performance sur 1 an',
            value: getPerf(support),
            options: { color: getPerfColor(support) },
          },
          {
            label: 'Niveau de risque',
            value: getRisk(support),
            options: { color: getRiskColor(support) },
          },
        ]"
        (onSelect)="onSupportSelect(support)"
        (onDeselect)="onSupportDeselect(support)"
        [withMoreInfoAnchor]="support.id"
        (onMoreInfoClick)="onMoreInfoClick(support)"
      >
      </pr-form-select-list-option>
    }
  </pr-form-select-list>
  <mat-paginator
    [length]="supportsLength"
    [pageSize]="supportsPageSize"
    (page)="changeSupportsPage($event)"
  >
  </mat-paginator>
  <div [class]="'one-button'">
    <pr-button
      display="neutral"
      size="lg"
      title="Valider"
      label="Valider"
      (onClick)="validateAddSupport()"
    ></pr-button>
  </div>
</pr-modal>
